// @ts-nocheck
import {
  MAC_POLICY_SET_ID,
  getAssetTabIconName
} from '@nile/banyan/src/Constants/policySet';
import { TerminalFill } from '@styled-icons/bootstrap/TerminalFill';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
// import TestComponent from './TestComponent';
import {
  ALL_MODULES,
  Asset,
  AssetsTabIcon,
  ChartTabIcon,
  Clients,
  ClientTabIcon,
  HomeTabIcon,
  ITDocsTabIcon,
  FeedBackIcon,
  ITDocumentationTabIcon,
  MacIcon,
  MyWorkspace,
  NewAlertTabIcon,
  NewAssetTabIcon,
  NewPatchTabIcon,
  ProjectTabIcon,
  Reports,
  ReportTabIcon,
  RequesterTabIcon,
  ScriptsTabIcon,
  CommunityScriptTabIcon,
  SiteTabIcon,
  SettingsIcon,
  TicketTabIcon,
  MailTabIcon,
  WindowsIcon,
  ClientHomeTabIcon,
  ProductOnboard,
  TAB_PAGES,
  CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME,
  MigrateData,
  NetworkMonitorIcon,
  LinuxIcon,
  PrinterIcon,
  TimesheetData,
  SchedulingData,
  InsightTabIcon
} from '@nile/components';
import dompurify from 'dompurify';
import React, { Suspense, lazy } from 'react';
import { Tooltip } from 'react-clone-tippy';
import shortid from 'shortid';
import styled from 'styled-components';
import InvoiceIcon from '@nile/components/src/Svg/Invoice.svg';
import { Forum } from '@styled-icons/material-twotone';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import Tippy from '@tippyjs/react';

/* lazy load start */

const EditAlertNotificationTemplate = lazy(() =>
  import(
    '@nile/banyan/src/Pages/AlertNotificationTemplate/EditAlertNotificationTemplate'
  )
);
const NewAlertNotificationTemplate = lazy(() =>
  import(
    '@nile/banyan/src/Pages/AlertNotificationTemplate/NewAlertNotificationTemplate'
  )
);
const ClientUserPage = lazy(() =>
  import('@nile/banyan/src/Pages/Protected/Decider').then((module) => ({
    default: module.ClientUserPage
  }))
);
const AlertTicketTemplate = lazy(() =>
  import('@nile/banyan/src/Pages/Protected/Index').then((module) => ({
    default: module.AlertTicketTemplate
  }))
);
const OnboardPage = lazy(() =>
  import('@nile/banyan/src/Pages/Protected/Index').then((module) => ({
    default: module.OnboardPage
  }))
);
const ProfilePage = lazy(() =>
  import('@nile/banyan/src/Pages/Protected/Index').then((module) => ({
    default: module.ProfilePage
  }))
);
const NonMonitoredAssetCreatePage = lazy(() =>
  import('@nile/banyan/src/Pages/Protected/Index/NonMonitoredAssetCreatePage')
);

const ArticleHomePage = lazy(() =>
  import('@nile/rmm/src/modules/knowledge-base/subpages/article-page')
);

const ContractTemplatePage = lazy(() =>
  import('@nile/client_management/src/Pages/ContractTemplate')
);
const InvoiceDetails = lazy(() =>
  import('@nile/client_management/src/Pages/Invoice/InvoiceDetails')
);
const QuoteDetails = lazy(() =>
  import('@nile/client_management/src/Pages/Quote/QuoteDetails')
);
const ClientDetailsPage = lazy(() =>
  import('@nile/client_management/src/Pages/Protected/ClientDetailsPage')
);
const ClientNavigation = lazy(() =>
  import(
    '@nile/client_management/src/Pages/Protected/ClientNavigation/ClientNavigation'
  )
);
const ClientHomePageKB = lazy(() =>
  import('@nile/client_management/src/Pages/ClientKb')
);
const AgentMarketplace = lazy(() =>
  import('@nile/components/src/Pages/AgentMarketplace')
);
const ClientManagementPage = lazy(() =>
  import('@nile/client_management/src/Pages/Protected/ClientPage')
);
const CreateEmail = lazy(() =>
  import('@nile/client_management/src/Pages/Protected/CreateEmail')
);
const CreateInvoice = lazy(() =>
  import('@nile/client_management/src/Pages/Invoice/CreateInvoice')
);
const CreateQuote = lazy(() =>
  import('@nile/client_management/src/Pages/Quote/CreateQuote')
);
const SpeedTestPage = lazy(() =>
  import('@nile/mangifera/src/Pages/SpeedTestPage')
);

const StepNavigation = lazy(() =>
  import('@nile/mangifera/src/Components/Public/StepNavigation')
);
const MainContainer = lazy(() =>
  import('@nile/mangifera/src/Containers/ChatContainers').then((m) => ({
    default: m.MainContainer
  }))
);
const NewTicketContainer = lazy(() =>
  import('@nile/mangifera/src/Containers/FormContainers').then((m) => ({
    default: m.NewTicketContainer
  }))
);
const HomePage = lazy(() => import('@nile/mangifera/src/Pages/HomePage'));
const ProductOnboardingPage = lazy(() =>
  import('@nile/mangifera/src/Pages/ProductOnboard')
);
const MigrateDataPage = lazy(() =>
  import('@nile/mangifera/src/Pages/MigrateDataPage')
);
const TimeSheetPage = lazy(() =>
  import('@nile/mangifera/src/Pages/TimeSheetPage')
);
const SchedulingPage = lazy(() =>
  import('@nile/mangifera/src/Pages/SchedulingPage')
);
const ViewIndexPage = lazy(() =>
  import('@nile/mangifera/src/Pages/Protected/Ticket/ViewIndexPage')
);
const ProjectsPage = lazy(() =>
  import('@nile/projects/src/Pages').then((m) => ({ default: m.ProjectsPage }))
);
const EditReport = lazy(() =>
  import('@nile/reports/src/modules/reports/components/pages/EditReport')
);
const SharedReport = lazy(() =>
  import('@nile/reports/src/modules/reports/components/pages/SharedReport')
);
const AlertViewCreate = lazy(() =>
  import(
    '@nile/rmm/src/modules/alert-management/components/pages/alert-view-create-edit/AlertViewCreate'
  )
);
const AlertViewEdit = lazy(() =>
  import(
    '@nile/rmm/src/modules/alert-management/components/pages/alert-view-create-edit/AlertViewEdit'
  )
);
const AssetDetailsDashboard = lazy(() =>
  import(
    '@nile/rmm/src/modules/asset-management/components/pages/asset-details-dashboard/asset-details-dashboard'
  )
);
const AssetGroupViewCreateEditPage = lazy(() =>
  import(
    '@nile/rmm/src/modules/asset-management/components/pages/asset-group-create-edit'
  )
);
const AssetViewCreate = lazy(() =>
  import(
    '@nile/rmm/src/modules/asset-management/components/pages/asset-view-create-edit/AssetViewCreate'
  )
);
const AssetViewEdit = lazy(() =>
  import(
    '@nile/rmm/src/modules/asset-management/components/pages/asset-view-create-edit/AssetViewEdit'
  )
);
const CommunityScriptDetails = lazy(() =>
  import(
    '@nile/rmm/src/modules/script-library/components/community/CommunityScriptDetails'
  )
);
const ITDocumentationList = lazy(() =>
  import(
    '@nile/rmm/src/modules/it-documentation/components/pages/it-documentation-list'
  )
);
const ClientPortalITDocumentation = lazy(() =>
  import(
    '@nile/rmm/src/modules/it-documentation/components/pages/it-documentation-list/client-it-documentation'
  )
);
const NonMonitoredAssetCreate = lazy(() =>
  import(
    '@nile/rmm/src/modules/it-documentation/components/pages/non-monitored-asset-create'
  )
);
const NonMonitoredAssetDetails = lazy(() =>
  import(
    '@nile/rmm/src/modules/it-documentation/components/pages/non-monitored-asset-details'
  )
);
const PatchViewCreate = lazy(() =>
  import(
    '@nile/rmm/src/modules/patch-management/components/pages/patch-view-create-edit/PatchViewCreate'
  )
);
const PatchViewEdit = lazy(() =>
  import(
    '@nile/rmm/src/modules/patch-management/components/pages/patch-view-create-edit/PatchViewEdit'
  )
);
const ScriptDetailPage = lazy(() =>
  import('@nile/rmm/src/modules/scripts/components/sub-pages/edit-script')
);
const NewScriptPage = lazy(() =>
  import('@nile/rmm/src/modules/scripts/components/sub-pages/new-script')
);
const CreateEditPropForm = lazy(() =>
  import('@nile/rmm/src/snmp/shared/create-edit-prop/CreateEditPropForm')
);
const CreateEditCredentialForm = lazy(() =>
  import(
    '@nile/rmm/src/snmp/shared/create-edit-credential/CreateEditCredentialForm'
  )
);
const InsightsHome = lazy(() =>
  import('@nile/itsm/src/pages/insights/InsightsHome')
);
const AssetTerminalPage = lazy(() =>
  import(
    '@nile/rmm/src/modules/asset-management/components/pages/asset-details-toolbar/Terminal/asset-remote-terminal-page'
  )
);
const CannyWidget = lazy(() =>
  import('@nile/banyan/src/Components/Intergration/Canny/CannyWidget')
);
const ErrorPage = lazy(() =>
  import('@nile/components/src/Components/ErrorPage')
);

/** lazy load end */

const DashboardHome = lazy(() =>
  import('@nile/reports/src/modules/home/components/pages/Home')
);

const RMMHome = lazy(() =>
  import('@nile/rmm/src/modules/home/components/pages/RMM-home/RMM-home')
);

const ScriptsHome = lazy(() =>
  import(
    '@nile/rmm/src/modules/home/components/pages/Scripts-home/Scripts-home'
  )
);

const AdvancePolicyRulePage = lazy(() =>
  import('@nile/rmm/src/modules/advance-policy-rule')
);

// Import separate components for different requester group URLs
const RequesterGroupsList = lazy(() =>
  import('@nile/banyan/src/Pages/RequesterGroups/RequesterGroupsList')
);

const RequesterGroupForm = lazy(() =>
  import('@nile/banyan/src/Pages/RequesterGroups/RequesterGroupForm')
);

const StyledTerminalFill = styled(TerminalFill)`
  width: 15px;
  color: #000000;
`;

const tabIconMap = {
  SCHEDULING: <SchedulingData />,
  TIMESHEET: <TimesheetData />,
  PRODUCTONBOARD: <ProductOnboard />,
  MIGRATE_DATA: <MigrateData />,
  TICKET: <TicketTabIcon />,
  ASSET_DETAILS: <AssetsTabIcon />,
  ALL_ASSET_DETAILS: <AssetsTabIcon />,
  NON_MONITORED_ASSET_DETAILS: <ITDocsTabIcon />,
  KB_ARTICLE: <SVGIcon name="Summary" size="sm" />,
  [ALL_MODULES.projectDetail]: <ProjectTabIcon />,
  [ALL_MODULES.projectCreation]: <ProjectTabIcon />,
  CREATE_SCRIPT: <ScriptsTabIcon />,
  CREATE_PROBE: <ScriptsTabIcon />,
  CREATE_CREDENTIALS: <ScriptsTabIcon />,
  SCRIPT_DETAIL: <ScriptsTabIcon />,
  CLIENT: <ClientTabIcon />,
  ALL_CLIENTS: <Clients />,
  IT_INSIGHT: <InsightTabIcon />,
  SALES_INBOX: <Clients />,
  WORKSPACE: <MyWorkspace />,
  CLIENT_WORKSPACE: <ClientHomeTabIcon />,
  RMM_HOME: <Asset />,
  SCRIPTS_HOME: <CommunityScriptTabIcon />,
  COMMUNITY_SCRIPTS_DETAILS: <ScriptsTabIcon />,
  TICKET_VIEW: <TicketTabIcon />,
  NEW: <TicketTabIcon />,
  CLIENT_CREATION: <ClientTabIcon />,
  ADD_ALERT_VIEW: <NewAlertTabIcon />,
  UPDATE_ALERT_VIEW: <NewAlertTabIcon />,
  ADD_PATCH_VIEW: <NewPatchTabIcon />,
  UPDATE_PATCH_VIEW: <NewPatchTabIcon />,
  ADD_ASSET_GROUP_VIEW: <NewAssetTabIcon />,
  ADD_ASSET_VIEW: <NewAssetTabIcon />,
  CREATE_NON_MONITORED_ASSET_FORM: <ITDocsTabIcon />,
  SITE: <SiteTabIcon />,
  USER: <RequesterTabIcon />,
  CREATE_NON_MONITORED_ASSET: <ITDocsTabIcon />,
  UPDATE_ASSET: <ITDocsTabIcon />,
  ASSET_MAC: <MacIcon />,
  ASSET_WINDOWS: <WindowsIcon />,
  ASSET_LINUX: <LinuxIcon />,
  ASSET_ROUTER: <NetworkMonitorIcon name="RouterLight" />,
  ASSET_SWITCH: <NetworkMonitorIcon name="SwitchLight" />,
  ASSET_FIREWALL: <NetworkMonitorIcon name="FireWallLight" />,
  ASSET_PRINTER: <PrinterIcon />,
  REPORTS_CHARTS_HOME: <Reports />,
  REPORT_CREATION: <ReportTabIcon />,
  REPORT_DETAIL: <ReportTabIcon />,
  SHARED_REPORT: <ReportTabIcon />,
  CHART_CREATION: <ChartTabIcon />,
  CHART_DETAIL: <ChartTabIcon />,
  IT_DOCS: <ITDocumentationTabIcon />,
  CLIENT_IT_DOCS: <ITDocumentationTabIcon />,
  HOME: <HomeTabIcon />,
  INVOICE: <InvoiceIcon />,
  ONBOARD: <SettingsIcon />,
  CANNY_FEEDBACK: <FeedBackIcon />,
  PRODUCT_FORUM: <SVGIcon name="Forum" />,
  CREATE_TERMINAL_SESSION: <StyledTerminalFill />,
  CREATE_TICKET_TEMPLATE: <TicketTabIcon />,
  UPDATE_TICKET_TEMPLATE: <TicketTabIcon />,
  CREATE_ALERT_EMAIL_TEMPLATE: <MailTabIcon />,
  UPDATE_ALERT_EMAIL_TEMPLATE: <MailTabIcon />,
  [TAB_PAGES.mailbox]: <MailTabIcon />,
  [TAB_PAGES.newInvoice]: <InvoiceIcon />,
  [TAB_PAGES.newInvoiceFromSource]: <InvoiceIcon />,
  [TAB_PAGES.newQuote]: <InvoiceIcon />,
  [TAB_PAGES.quote]: <InvoiceIcon />,
  UPDATE_ASSET_VIEW: <NewAssetTabIcon />,
  UPDATE_ASSET_GROUP_VIEW: <NewAssetTabIcon />,
  NEW_CONTRACT_TEMPLATE: <SVGIcon name="Contract" />,
  EDIT_CONTRACT_TEMPLATE: <SVGIcon name="Contract" />,
  NON_MONITOR_ASSET: <SVGIcon name="System" />,
  ADVANCE_POLICY_RULE: <SVGIcon name="DiscoveredAssets" />,
  CLIENTHOMEKB: <ClientHomeTabIcon />,
  AGENTMARKETPLACE: <SVGIcon name="AgentAIColor" />,
  REQUESTER_GROUPS: <RequesterTabIcon />,
  ASSET_ANDROID: <SVGIcon name="AndroidLine" />,
  ASSET_APPLE_IOS: <SVGIcon name="IOSLine" />,
  ASSET_APPLE_IPAD_OS: <SVGIcon name="IPadLine" />
};

/**
 * Each tab should have an unique id.
 * This is also used to make sure we don't open the same tab twice.
 * @param {object} params
 */
const getTabId = (params) => {
  const { ticketId, id, module, data } = params;
  const tabId = params?.data?.id;
  switch (module) {
    case TAB_PAGES.scheduling:
      return 'scheduling';
    case 'TIMESHEET':
      return 'timesheet';
    case 'PRODUCTONBOARD':
      return 'product-onboard';
    case 'MIGRATE_DATA':
      return 'migrate-data';
    case `CREATE_TERMINAL_SESSION`:
      return `create-terminal-${shortid.generate()}`;
    case 'ONBOARD':
      return 'onboard-tab';
    case 'HOME':
      return 'home-tab';
    case 'PRICING':
      return 'pricing-tab';
    case 'TICKET':
      return `ticket-item-${data.ticketId}`;
    case 'USER':
      return tabId ? `user-${tabId}` : 'new-user';
    case 'WORKSPACE':
      return `workspace`;
    case 'ALL_CLIENTS':
      return `clients`;
    case 'IT_INSIGHT':
      return `it-insight`;
    case 'SALES_INBOX':
      return `client`;
    case 'NEW':
      return 'new-tab';
    case 'CLIENT_CREATION':
      return `create-client`;
    case 'CLIENT':
      return `client-${data.id}`;
    case 'SITE':
      return tabId ? `site-${tabId}` : 'site-new';
    case 'TICKET_VIEW':
      return tabId ? `view-${tabId}` : 'new-view';
    case ALL_MODULES.projectDetail:
      return `project-${data.projectId}`;
    case 'PROFILE':
      return 'profile';
    case ALL_MODULES.projectCreation:
      return data?.ticketId
        ? `create-project-${data.ticketId}`
        : `create-project`;
    case 'ADD_ALERT_VIEW':
      return 'add-alert-view';
    case 'ADD_ASSET_GROUP_VIEW':
      return 'add-asset-group-view';
    case 'ADD_ASSET_VIEW':
      return 'add-asset-view';
    case 'ADD_PATCH_VIEW':
      return 'add-patch-view';
    case 'UPDATE_ASSET_GROUP_VIEW':
      return `update-asset-group-view-${params?.data?.id}`;
    case 'UPDATE_ASSET_VIEW':
      return `update-asset-view-${params?.data?.id}`;
    case 'UPDATE_ALERT_VIEW':
      return `update-alert-view-${params?.data?.id}`;
    case 'UPDATE_PATCH_VIEW':
      return `update-patch-view-${params?.data?.id}`;
    case `ASSET_DETAILS`:
      return `asset-details-${params?.data?.id}`;
    case `ALL_ASSET_DETAILS`:
      return `all-asset-details-${params?.data?.id}`;
    case `CREATE_NON_MONITORED_ASSET_FORM`:
      return `create-non-monitored-asset-form`;
    case `CREATE_NON_MONITORED_ASSET`:
      return `create-asset-${params.data.entityName}/${params.data.classId}`;
    case 'NON_MONITORED_ASSET_DETAILS':
      return `non-monitored-asset-details-${params.data.classId}/${params.data.assetId}`;
    case 'RMM_HOME':
      return 'rmm-home';
    case 'SCRIPTS_HOME':
      return 'script-home';
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return `community-script-details-${data.id}`;
    case 'IT_DOCS':
      return 'itDocs';
    case 'CLIENT_IT_DOCS':
      return 'client-it-doc';
    case 'CREATE_SCRIPT':
      return 'create-script';
    case 'CREATE_PROBE':
      return 'create-probe';
    case 'CREATE_CREDENTIALS':
      return 'create-credential';
    case 'SCRIPT_DETAIL':
      return `script-${data.scriptId}`;
    case 'NEW_CONTRACT_TEMPLATE':
      return `new-contract-template`;
    case 'EDIT_CONTRACT_TEMPLATE':
      return `edit-contract-template-${params.data.templateId}`;
    case 'REPORTS_CHARTS_HOME':
      return 'reports-charts';
    case 'REPORT_CREATION':
      return 'create-report';
    case 'REPORT_DETAIL':
      return `report-${data.reportId}`;
    case 'SHARED_REPORT':
      return `sharedreport-${data.reportId}`;
    case 'CHART_CREATION':
      return 'create-chart';
    case 'CHART_DETAIL':
      return `chart-${data.chartId}`;
    case 'INVOICE':
      return `invoice-${data.invoiceId}`;
    case 'QUOTE':
      return `quote-${data.quoteId}`;
    case 'CREATE_TICKET_TEMPLATE':
      return `alert-ticket-template-create`;
    case 'UPDATE_TICKET_TEMPLATE':
      return `alert-ticket-template-edit`;
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return `alert-email-template-create`;
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return `alert-email-template-edit`;
    case 'CANNY_FEEDBACK':
      return `feedback`;
    // case 'PRODUCT_FORUM':
    //   return `forum`;
    case TAB_PAGES.mailbox:
      return 'create-email';
    case TAB_PAGES.newInvoice:
      return 'create-invoice';
    case TAB_PAGES.newInvoiceFromSource:
      return `create-invoice-${params.id}`;
    case TAB_PAGES.newQuote:
      return 'create-quote';
    case 'ADVANCE_POLICY_RULE':
      return 'advance-policy-rule';
    case 'KB_ARTICLE':
      return `kb-${data.itemId || data.id}`;
    case 'CLIENTHOMEKB':
      return 'CLIENTHOMEKB';
    case 'AGENTMARKETPLACE':
      return 'AGENTMARKETPLACE';
    case 'REQUESTER_GROUPS':
      return 'requester-groups-list';
    case 'NEW_REQUESTER_GROUP':
      return 'new-requester-group';
    case 'EDIT_REQUESTER_GROUP':
      return `requester-group-${data.id}`;
    default:
      return '';
  }
};

/**
 * If a tab has url redirection, we need to specify it here.
 * Else the route won't be changed in the application.
 * @param {object} params
 */
const getTabUrlNew = (params) => {
  const {
    ticketId,
    tab,
    module,
    pageName,
    data,
    url,
    urlParams,
    queryParams,
    getAllURL
  } = params;

  const allUrl = {
    SCHEDULING: {
      url: `/scheduling`,
      path: `/scheduling`
    },
    TIMESHEET: {
      url: `/timesheet`,
      path: `/timesheet`
    },
    PRODUCTONBOARD: {
      url: `/productonboard`,
      path: `/productonboard`
    },
    MIGRATE_DATA: { url: `/migrate`, path: `/migrate` },
    ONBOARD: {
      url: `/onboard/profile`,
      path: [
        '/onboard/:category',
        '/onboard/:category/:id',
        '/onboard/invoicesettings/:id/:id2',
        '/onboard/serviceCatalog',
        '/onboard/employee/:id/:type/',
        '/onboard/employee/:id/:type',
        '/marketplace/integrations/:type',
        '/onboard/integrations/:type',
        '/onboard/holidays/:id/:type/:year',
        '/onboard/holidays/:id/:type',
        '/onboard/softwarebundle/:id/:type',
        '/onboard/onboardingtemplates/:id/:type',
        '/onboard/ticketingtemplates/:id/:type',
        '/onboard/tasktemplates/:id/:type',
        '/onboard/clienttemplates/:id/:type',
        '/onboard/reply/:id/:type',
        '/onboard/projecttemplate/:id/:type',
        '/onboard/chattemplate/:id/:type',
        '/onboard/serviceCatalog/:id/:type',
        '/onboard/contractTemplate/:id/:type',
        '/onboard/roles/:pagename/:id/:type',
        '/onboard/techniciangroup/:id/:type',
        '/onboard/sla/:id/:type',
        '/onboard/eventtrigger/12/new/:id',
        '/onboard/eventtrigger/:id/:type/:group/',
        '/onboard/eventtrigger/:id/:type/:group/:ruleId',
        '/onboard/timetrigger/:id/:type',
        '/onboard/ticketscheduler/:id/:type',
        '/onboard/non-monitored-asset/create',
        '/onboard/custom-network-assets/create',
        '/onboard/unmonitored-asset/create',
        '/onboard/unmonitored-asset/update/:id',
        '/onboard/non-monitored-asset/update/:id',
        '/onboard/unmonitored-asset/update',
        '/onboard/tasktemplate/:id/:type',
        '/onboard/fields/:id/:type',
        '/onboard/formbuilder/:id/:type',
        '/onboard/soplist/:id/:type',
        '/onboard/policymgmt-new/edit/:id/:category',
        '/onboard/policymgmt/create/:classId',
        '/onboard/invoicesettings/:id/:templateId',
        '/onboard/invoiceTemplate/:templateId/:mode',
        '/onboard/quotesettings/:id/:templateId',
        '/onboard/requester-groups',
        '/onboard/requester-groups/new',
        '/onboard/requester-group/:id',
        '/onboard/mdm-client-setup/:id',
        '/onboard/invoiceSchedule',
        '/onboard/invoiceTemplates'
      ]
    },
    HOME: { url: `/home`, path: '/home' },
    PRICING: { url: `/pricing`, path: '/pricing' },
    TICKET: {
      url: `/tickets/${data?.ticketId}/ticket`,
      path: '/tickets/:ticketId/ticket'
    },
    USER: {
      url: `/clientuser/${params?.data?.clientId}/${params?.data?.id}/${params?.data?.type}`,
      path: '/clientuser/:clientId/:dataId/:dataType}'
    },
    NEW: { url: `/ticket/aWqgT35s/new`, path: ['/ticket/aWqgT35s/new'] },
    [ALL_MODULES.projectCreation]: {
      url: `/project/B604yRELWW/new`,
      path: ['/project/B604yRELWW/new', `/project/:id/new`]
    },
    WORKSPACE: {
      url: `/ticket/1/ticket-list`,
      path: [
        '/ticket/:ticketId/:ticket-list',
        '/tasks/:id/task-list',
        '/project/:id/:project-list',
        '/monica-ai/:id/list'
      ]
    },
    CLIENT_CREATION: {
      url: `/client/${shortid.generate()}/new`,
      path: '/client/:shortid/new'
    },
    CLIENT: {
      url: `/client/${params?.data?.id}/detail`,
      path: [
        '/client/:id/detail',
        '/client/:id/detail/contracts',
        '/client/:id/detail/contracts/:contractId',
        '/client/:id/detail/invoiceAuditViews/:id/:name',
        '/client/:id/detail/invoiceConfiguration/:id/:name',
        '/client/:id/detail/mailBoxViews/:id/:name',
        '/client/:id/detail/invoiceViews/:id/invoice-list',
        '/client/:id/detail/invoiceViews/:id/:name',
        '/client/:id/detail/clientViews/:id/client-list',
        '/client/:id/detail/contractViews/:id/:name',
        '/client/:id/detail/quoteViews/:id/:name',
        '/client/:id/detail/itdocs/Password&&1001',
        '/client/:id/detail/itdocs/:id'
      ]
    },
    ALL_CLIENTS: {
      url: '/clientViews/3001/client-list',
      path: [
        '/invoiceViews/:id/invoice-list',
        '/invoiceViews/:id/:category',
        '/clientViews/:id/:category',
        '/mailBoxViews/:id/:category',
        '/contractViews/:id/:category',
        '/invoiceAuditViews/:id/:category',
        '/quoteViews/:id/:category',
        '/paymentViews/:id/:category'
      ]
    },
    IT_INSIGHT: {
      url: `/itsm/insights/${params?.data?.type}/${params?.data?.id}`,
      path: [
        '/itsm/insights/:type',
        '/itsm/insights/:type/:id',
        '/itsm/insights/:type/:id/:section/:tab'
      ]
    },
    SITE: {
      url: `/sites/${params?.data?.clientId}/${params?.data?.id}/${params?.data?.type}`,
      path: '/sites/:clientId/:id/:type'
    },
    TICKET_VIEW: {
      url: (() => {
        if (params?.data?.id) {
          return `/ticketView/${params?.data?.id}/${params?.data?.type}`;
        }
        return `/ticketView/${shortid.generate()}/${params?.data?.type}`;
      })(),
      path: '/ticketView/:shortid/:type'
    },
    [ALL_MODULES.projectDetail]: {
      url: `/project/${data?.projectId}/detail`,
      path: '/project/:projectId/detail'
    },
    PROFILE: { url: `/profile/detail/edit`, path: ['/profile/detail/edit'] },
    ADD_ALERT_VIEW: {
      url: `/rmm/alert/${shortid.generate()}/create`,
      path: '/rmm/alert/:shortid/create'
    },
    ADD_PATCH_VIEW: {
      url: `/rmm/patch/${shortid.generate()}/create`,
      path: '/rmm/patch/:shortid/create'
    },
    ADD_ASSET_GROUP_VIEW: {
      url: `/rmm/asset-group/${shortid.generate()}/create`,
      path: '/rmm/asset-group/:shortid/create'
    },
    ADD_ASSET_VIEW: {
      url: `/rmm/asset-view/${shortid.generate()}/create`,
      path: '/rmm/asset-view/:shortid/create'
    },
    UPDATE_ASSET_GROUP_VIEW: {
      url: `/rmm/asset-group/${params?.data?.id}/update`,
      path: '/rmm/asset-group/:id/update'
    },
    UPDATE_ASSET_VIEW: {
      url: `/rmm/asset-view/${params?.data?.id}/update`,
      path: '/rmm/asset-view/:id/update'
    },
    UPDATE_ALERT_VIEW: {
      url: `/rmm/alert/${params?.data?.id}/update`,
      path: '/rmm/alert/:id/update'
    },
    UPDATE_PATCH_VIEW: {
      url: `/rmm/patch/${params?.data?.id}/update`,
      path: '/rmm/patch/:id/update'
    },
    CREATE_TERMINAL_SESSION: {
      url: `/rmm/remoteterminal/${params?.data?.id}`,
      path: [
        '/rmm/remoteterminal/:id',
        '/rmm/remoteterminal/:id/:networkAssetId',
        '/rmm/remoteterminal/:assetId/:uniqueId/:loginType/:termType',
        '/rmm/remoteterminal/:assetId/:uniqueId/:loginType/:termType/:networkAssetId'
      ]
    },
    ALL_ASSET_DETAILS: {
      url: `/rmm/details/asset/${params?.data?.id}/${params?.data?.classId}`,
      path: '/rmm/details/asset/:id/:classId'
    },
    ASSET_DETAILS: {
      url: `/rmm/asset/details/${params?.data?.id}`,
      path: '/rmm/asset/details/:id'
    },
    CREATE_NON_MONITORED_ASSET_FORM: {
      url: `/non-monitored-asset-form/create`,
      path: '/non-monitored-asset-form/create'
    },
    CREATE_NON_MONITORED_ASSET: {
      url: `/rmm/asset/${params?.data?.entityName}/${
        params?.data?.classId
      }/${shortid.generate()}/create`,
      path: '/rmm/asset/:entityName/:classId/:shortid/create'
    },
    CREATE_SCRIPT: {
      url: `/rmm/script/${shortid.generate()}/create`,
      path: '/rmm/script/:shortid/create'
    },
    SCRIPT_DETAIL: {
      url: `/rmm/script/${data?.scriptId}/detail`,
      path: '/rmm/script/:scriptId/detail'
    },
    CREATE_PROBE: {
      url: `/rmm/probe/TxMcMMvvx/create`,
      path: `/rmm/probe/TxMcMMvvx/create`
    },
    NON_MONITORED_ASSET_DETAILS: {
      url: `/rmm/non-monitored-asset/details/${params?.data?.entityName}/${params?.data?.classId}/${params?.data?.assetId}`,
      path: '/rmm/non-monitored-asset/details/:entityName/:classId/:assetId'
    },
    RMM_HOME: {
      url: `/rmm/patch/${params?.data?.id}`,
      path: [
        '/rmm/patch/all',
        '/rmm/asset-view/:id',
        '/rmm/patch/:id',
        `/rmm/network-view/:id`,
        '/rmm/alert/:id',
        '/rmm/asset-group/:id',
        '/client/rmm/asset-view/:id',
        '/rmm/maintenance-mode/:id',
        '/rmm/executed-scripts/:id',
        '/rmm/device-category/:id',
        '/rmm/monica-ai/:id'
      ]
    },
    COMMUNITY_SCRIPTS_DETAILS: {
      url: `/rmm/scripts-library/${params?.data?.type}/${params?.data?.id}/detail`,
      path: '/rmm/scripts-library/:type/:id/detail'
    },
    SCRIPTS_HOME: {
      url: `/rmm/scripts-library/${params?.data?.type}/${params?.data?.id}`,
      path: ['/rmm/scripts-library/:type/:id']
    },
    CREATE_CREDENTIALS: {
      url: `/rmm/scripts-library/${params?.data?.type}/${params?.data?.id}/create`,
      path: '/rmm/credential/TxMcMMvvx/create'
    },
    IT_DOCS: {
      url: `/rmm/itdoc/${data?.entityName || 'Password'}&&${data?.classId ||
        '1001'}`,
      path: ['/rmm/itdoc/:entityName&&:classId', '/kb/:section/:view']
    },
    KB_ARTICLE: {
      url: `/kb/article/${data?.id}/${data?.type}`,
      path: '/kb/article/:id/:type'
    },
    CLIENT_IT_DOCS: {
      url: `/client/rmm/itdoc/${data?.entityName ||
        CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME}&&${data?.classId || '1001'}`,
      path: '/client/rmm/itdoc/:entityName'
    },
    NEW_CONTRACT_TEMPLATE: {
      url: `/contracttemplate/H2Es51Am/new`,
      path: '/contracttemplate/:id/new'
    },
    EDIT_CONTRACT_TEMPLATE: {
      url: `/contracttemplate/${data?.templateId}/edit`,
      path: '/contracttemplate/:templateId/edit'
    },
    REPORTS_CHARTS_HOME: {
      url: `/charts/2001/All Charts`,
      path: [
        '/charts/:id/:category',
        '/report/:id/:category',
        '/pdfreport/:id/:category',
        '/efficiency/:id/:category',
        '/profitablity/:id/:category',
        '/datareport/:reportId/view'
      ]
    },
    REPORT_DETAIL: {
      url: `/report/${data?.reportId}/detail`,
      path: '/report/:reportId/detail'
    },
    SHARED_REPORT: {
      url: `/sharedreport/${data?.reportId}/view`,
      path: '/sharedreport/:reportId/view'
    },
    CHART_CREATION: {
      url: `/chart/B604yRELWW/new`,
      path: '/chart/B604yRELWW/new'
    },
    CHART_DETAIL: {
      url: `/chart/${data?.chartId}/detail`,
      path: '/chart/:chartId/detail'
    },
    INVOICE: {
      url: `/invoiceList/${data?.invoiceId}/detail`,
      path: '/invoiceList/:invoiceId/detail'
    },
    [TAB_PAGES.quote]: {
      url: `/quoteList/${data?.quoteId}/detail`,
      path: '/quoteList/:quoteId/detail'
    },
    CREATE_TICKET_TEMPLATE: {
      url: `/onboard/alert-ticket-template-create`,
      path: '/onboard/alert-ticket-template-create'
    },
    UPDATE_TICKET_TEMPLATE: {
      url: `/onboard/alert-ticket-template/edit/${params?.data?.id}`,
      path: '/onboard/alert-ticket-template/edit/:id'
    },
    CREATE_ALERT_EMAIL_TEMPLATE: {
      url: `/onboard/alertTemplate/${params?.data?.id}/new`,
      path: '/onboard/alertTemplate/:id/new'
    },
    UPDATE_ALERT_EMAIL_TEMPLATE: {
      url: `/onboard/alertTemplate/${params?.data?.id}/edit`,
      path: '/onboard/alertTemplate/:id/edit'
    },
    CANNY_FEEDBACK: {
      url: `/product/feedback`,
      path: ['/product/feedback', '/product/feedback/', '/product/forum']
    },
    // PRODUCT_FORUM: {
    //   url: `/product/feedback?tab=forum`,
    //   path: ['/product/forum']
    // },
    [TAB_PAGES.mailbox]: { url: `/mail/create`, path: '/mail/create' },
    [TAB_PAGES.newInvoice]: { url: `/invoice/create`, path: '/invoice/create' },
    [TAB_PAGES.newInvoiceFromSource]: {
      url: (() => {
        if (data?.action) {
          if (data?.module === ALL_MODULES.ticket) {
            return `/invoice/${data?.ticket?.ticketId}/create`;
          }
          if (data?.module === ALL_MODULES.project) {
            return `/invoice/${data?.project?.projectId}/create`;
          }
        }
        return `/invoice/create`;
      })(),
      path: ['/invoice/:ticketId/create', '/invoice/:projectId/create']
    },

    [TAB_PAGES.newInvoice]: {
      url: `/invoice/create`,
      path: '/invoice/create'
    },
    [TAB_PAGES.newQuote]: { url: `/quote/create`, path: '/quote/create' },
    ADVANCE_POLICY_RULE: {
      url: `/rmm/advance-policy-rule`,
      path: '/rmm/advance-policy-rule'
    },
    SPEEDTEST: {
      url: '/speedtest',
      path: '/speedtest'
    },
    CLIENTHOMEKB: {
      url: '/client-home',
      path: ['/client-home', '/client-home/', '/client-home/:id']
    },
    AGENTMARKETPLACE: {
      url: '/agent/marketplace',
      path: [
        '/agent/marketplace',
        '/agent/marketplace/',
        '/agent/marketplace/:category',
        '/agent/marketplace/:category/',
        '/agent/marketplace/:id/:name/:type',
        '/agent/marketplace/:id/:name/:type/'
      ]
    },
    REQUESTER_GROUPS: {
      url: '/onboard/requester-groups',
      path: '/onboard/requester-groups'
    },
    NEW_REQUESTER_GROUP: {
      url: '/onboard/requester-groups/new',
      path: '/onboard/requester-groups/new'
    },
    EDIT_REQUESTER_GROUP: {
      url: '/onboard/requester-group/:id',
      path: '/onboard/requester-group/:id'
    },
    MDM_CLIENT_SETUP: {
      url: '/onboard/mdm-client-setup/:id',
      path: '/onboard/mdm-client-setup/:id'
    },
    NOTFOUND: {
      url: '/:urlnotfound',
      path: '/:urlnotfound'
    }
  };

  if (getAllURL) {
    return allUrl;
  }
  return url
    ? `${url}${queryParams || ''}`
    : allUrl[module]?.url || '/:urlnotfound';
};

/**
 * If a tab has url redirection, we need to specify it here.
 * Else the route won't be changed in the application.
 * @param {object} params
 */
const getTabUrl = (params) => {
  const { ticketId, tab, module, pageName, data, url, queryParams } = params;
  switch (module) {
    case 'SCHEDULING':
      return `/scheduling`;
    case 'CLIENTHOMEKB':
      return `/client-home`;
    case 'AGENTMARKETPLACE':
      return `/agent/marketplace`;
    case 'TIMESHEET':
      return `/timesheet`;
    case 'PRODUCTONBOARD':
      return `/productonboard`;
    case 'MIGRATE_DATA':
      return '/migrate';
    case 'ONBOARD':
      return url || `/onboard/profile`;
    case 'HOME':
      return `/home`;
    case 'PRICING':
      return `/pricing`;
    case 'TICKET':
      return `/tickets/${data.ticketId}/ticket`;
    case 'USER':
      return `/clientuser/${params.data.clientId}/${params.data.id}/${params.data.type}`;
    case 'WORKSPACE':
      return url ? `${url}${queryParams || ''}` : `/ticket/1/ticket-list`;
    case 'ALL_CLIENTS':
      return url || '/clientViews/3001/client-list';
    case 'IT_INSIGHT':
      return url || `/itsm/insights/${params.data.type}/${params.data.id}`;
    case 'SALES_INBOX':
      return url
        ? `${url}${queryParams || ''}`
        : `mailBoxViews/5004/All Conversations`;
    case 'NEW':
      return '/ticket/aWqgT35s/new';
    case 'CLIENT_CREATION':
      return `/client/B604yRELWW/new`;
    case 'CLIENT':
      return url
        ? `${url}${queryParams || ''}`
        : `/client/${params.data.id}/detail`;
    case 'SITE':
      return `/sites/${params.data.clientId}/${params.data.id}/${params.data.type}`;
    case 'TICKET_VIEW':
      return `/ticketView/${params.data.id}/${params.data.type}`;
    case ALL_MODULES.projectDetail:
      return `/project/${data.projectId}/detail`;
    case 'PROFILE':
      return '/profile/detail/edit';
    case ALL_MODULES.projectCreation:
      return `/project/B604yRELWW/new`;
    case 'ADD_ALERT_VIEW':
      return `/rmm/alert/${shortid.generate()}/create`;
    case 'ADD_PATCH_VIEW':
      return `/rmm/patch/${shortid.generate()}/create`;
    case 'ADD_ASSET_GROUP_VIEW':
      return `/rmm/asset-group/${shortid.generate()}/create`;
    case 'ADD_ASSET_VIEW':
      return `/rmm/asset-view/${shortid.generate()}/create`;
    case 'UPDATE_ASSET_GROUP_VIEW':
      return `/rmm/asset-group/${params.data.id}/update`;
    case 'UPDATE_ASSET_VIEW':
      return `/rmm/asset-view/${params.data.id}/update`;
    case 'UPDATE_ALERT_VIEW':
      return `/rmm/alert/${params.data.id}/update`;
    case 'UPDATE_PATCH_VIEW':
      return `/rmm/patch/${params.data.id}/update`;
    case 'CREATE_TERMINAL_SESSION':
      return `/rmm/remoteterminal/${params.data.id}`;
    case 'ASSET_DETAILS':
      return `/rmm/asset/details/${params.data.id}`;
    case 'ALL_ASSET_DETAILS':
      return `/rmm/asset/details/${params.data.id}/${params.data.classId}`;
    case `CREATE_NON_MONITORED_ASSET_FORM`:
      return `/non-monitored-asset-form/create`;
    case 'CREATE_NON_MONITORED_ASSET':
      return `/rmm/asset/${params.data.entityName}/${
        params.data.classId
      }/${shortid.generate()}/create`;
    case 'CREATE_SCRIPT':
      return `/rmm/script/${shortid.generate()}/create`;
    case 'CREATE_PROBE':
      return `/rmm/probe/${shortid.generate()}/create`;
    case 'CREATE_CREDENTIALS':
      return `/rmm/credential/${shortid.generate()}/create`;
    case 'SCRIPT_DETAIL':
      return `/rmm/script/${data.scriptId}/detail`;
    case 'NON_MONITORED_ASSET_DETAILS':
      return `/rmm/non-monitored-asset/details/${params.data.entityName}/${params.data.classId}/${params.data.assetId}`;
    case 'RMM_HOME':
      return url || `/rmm/patch/all`;
    case 'SCRIPTS_HOME':
      return `/rmm/scripts-library/${params.data.type}/${params.data.id}`;
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return `/rmm/scripts-library/${params.data.type}/${params.data.id}`;
    case 'IT_DOCS':
      return `/rmm/itdoc/${data.entityName || 'Password'}&&${data.classId ||
        '1001'}`;
    case 'KB_ARTICLE':
      return `/kb/article/${params.data.id}/${params.data.type}`;
    case 'CLIENT_IT_DOCS':
      return `/client/rmm/itdoc/${data.entityName ||
        CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME}&&${data.classId || '1001'}`;
    case 'NEW_CONTRACT_TEMPLATE':
      return `/contracttemplate/H2Es51Am/new`;
    case 'EDIT_CONTRACT_TEMPLATE':
      return `/contracttemplate/${data.templateId}/edit`;
    case 'REPORTS_CHARTS_HOME':
      return url || '/charts/2001/All Charts';
    case 'REPORT_CREATION':
      return '/report/B604yRELWW/new';
    case 'REPORT_DETAIL':
      return `/report/${data.reportId}/detail`;
    case 'SHARED_REPORT':
      return `/sharedreport/${data.reportId}/view`;
    case 'CHART_CREATION':
      return '/chart/B604yRELWW/new';
    case 'CHART_DETAIL':
      return `/chart/${data.chartId}/detail`;
    case 'INVOICE':
      return url
        ? `${url}${queryParams || ''}`
        : `/invoiceList/${data.invoiceId}/detail`;
    case TAB_PAGES.quote:
      return url
        ? `${url}${queryParams || ''}`
        : `/quoteList/${data.quoteId}/detail`;
    case 'CREATE_TICKET_TEMPLATE':
      return `/onboard/alert-ticket-template-create`;
    case 'UPDATE_TICKET_TEMPLATE':
      return `/onboard/alert-ticket-template/edit/${params.data.id}`;
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return `/onboard/alertTemplate/${params.data.id}/new`;
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return `/onboard/alertTemplate/${params.data.id}/edit`;
    case 'CANNY_FEEDBACK':
      return `/product/feedback`;
    // case 'PRODUCT_FORUM':
    //   return `/product/forum`;
    case TAB_PAGES.mailbox:
      return `/mail/create`;
    case TAB_PAGES.newInvoice:
      return `/invoice/create`;
    case TAB_PAGES.newInvoiceFromSource:
      if (data?.action) {
        if (data?.module === ALL_MODULES.ticket) {
          return `/invoice/${data?.ticket?.ticketId}/create`;
        } else if (data?.module === ALL_MODULES.project) {
          return `/invoice/${data?.project?.projectId}/create`;
        }
      } else {
        return `/invoice/create`;
      }
    case TAB_PAGES.newQuote:
      return `/quote/create`;
    case 'SPEEDTEST':
      return '/speedtest';
    case 'ADVANCE_POLICY_RULE':
      return '/rmm/advance-policy-rule';
    case 'REQUESTER_GROUPS':
      return '/onboard/requester-groups';
    case 'NEW_REQUESTER_GROUP':
      return '/onboard/requester-groups/new';
    case 'EDIT_REQUESTER_GROUP':
      return `/onboard/requester-group/${data.id}`;
    case 'MDM_CLIENT_SETUP':
      return `/onboard/mdm-client-setup/${params.data.id}`;
    default:
      return '';
  }
};

/**
 * If the tabs overflow, we show a menu where we show list of tabs.
 * Content for that is specified here.
 * @param {object} params
 */
const getTabDisplayData = (params) => {
  const { ticketId, tab, module, pageName, data } = params;
  switch (module) {
    case 'CLIENTHOMEKB':
      return {
        name: 'CLIENTHOMEKB',
        label: `CLIENTHOMEKB`
      };
    case 'AGENTMARKETPLACE':
      return {
        name: 'AGENTMARKETPLACE',
        label: `AGENTMARKETPLACE`
      };
    case 'TIMESHEET':
      return {
        name: 'TIMESHEET',
        label: `Timesheets`
      };
    case 'PRODUCTONBOARD':
      return {
        name: 'PRODUCTONBOARD',
        label: `Product onboarding`
      };
    case 'MIGRATE_DATA':
      return {
        name: 'MIGRATE_DATA',
        label: 'Migrate Data'
      };
    case 'ONBOARD':
      return {
        name: 'ONBOARD',
        label: `Settings`
      };
    case 'HOME':
      return {
        name: 'HOME',
        label: `Home`
      };
    case 'PRICING':
      return {
        name: 'PRICING',
        label: `Pricing`
      };
    case 'TICKET':
      return {
        name: 'TICKET',
        label: `Ticket #${data.ticketId.slice(
          data.ticketId.length - 5,
          data.ticketId.length
        )}`
      };
    case 'USER':
      return {
        name: 'USER',
        label: params?.data?.value ? 'Edit requester' : 'New requester'
      };
    case 'WORKSPACE':
      return {
        name: 'WORKSPACE',
        label: 'mY WORKSPACE'
      };
    case 'ALL_CLIENTS':
      return {
        name: 'ALL_CLIENTS',
        label: 'Clients'
      };
    case 'IT_INSIGHT':
      return {
        name: 'IT_INSIGHT',
        label: 'My Organization'
      };
    case 'SALES_INBOX':
      return {
        name: 'ALL_CLIENTS',
        label: 'Clients'
      };
    case 'NEW':
      return {
        name: 'NEW_TICKET',
        label: 'New Ticket'
      };
    case 'CLIENT_CREATION':
      return {
        name: 'CLIENT_CREATION',
        label: 'New Client'
      };
    case 'CLIENT':
      return {
        name: 'CLIENT',
        label: params.data.value
      };
    case 'SITE':
      return {
        name: 'SITE',
        label: params?.data?.value || 'New Site'
      };
    case 'TICKET_VIEW':
      return {
        name: 'TICKET_VIEW',
        label: params?.data?.value || 'New ticket view'
      };
    case ALL_MODULES.projectDetail:
      return {
        name: ALL_MODULES.projectDetail,
        label: data.title
      };
    case 'PROFILE':
      return {
        name: 'PROFILE',
        label: 'My Profile'
      };
    case ALL_MODULES.projectCreation:
      return {
        name: ALL_MODULES.projectCreation,
        label: 'New Project'
      };
    case 'CREATE_NON_MONITORED_ASSET':
      return {
        name: 'CREATE_NON_MONITORED_ASSET',
        label: 'Create Asset'
      };
    case 'CREATE_TERMINAL_SESSION':
      return {
        name: 'CREATE_TERMINAL_SESSION',
        label: data.title || 'Create Terminal'
      };
    case 'CREATE_SCRIPT':
      return {
        name: 'CREATE_SCRIPT',
        label: 'New Script'
      };
    case 'CREATE_PROBE':
      return {
        name: 'CREATE_PROBE',
        label: 'New Probe'
      };
    case 'CREATE_CREDENTIALS':
      return {
        name: 'CREATE_CREDENTIALS',
        label: 'New credential'
      };
    case 'SCRIPT_DETAIL':
      return {
        name: 'SCRIPT_DETAIL',
        label: data.title || 'Script detail'
      };
    case 'NON_MONITORED_ASSET_DETAILS':
      return {
        name: 'NON_MONITORED_ASSET_DETAILS',
        label: 'Non Monitored Asset Details'
      };
    case 'RMM_HOME':
      return {
        name: 'RMM_HOME',
        label: 'RMM Home'
      };
    case 'SCRIPTS_HOME':
      return {
        name: 'SCRIPTS_HOME',
        label: 'Scripts Home'
      };
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return {
        name: 'COMMUNITY_SCRIPTS_DETAILS',
        label: data.title || 'Community script details'
      };
    case 'IT_DOCS':
      return {
        name: 'IT_DOCS',
        label: 'Documentation'
      };
    case 'CLIENT_IT_DOCS':
      return {
        name: 'CLIENT_IT_DOCS',
        label: 'IT Documentation'
      };
    case 'NEW_CONTRACT_TEMPLATE':
      return {
        name: 'NEW_CONTRACT_TEMPLATE',
        label: 'New contract template'
      };
    case 'EDIT_CONTRACT_TEMPLATE':
      return {
        name: 'EDIT_CONTRACT_TEMPLATE',
        label: 'Edit contract template'
      };
    case 'REPORTS_CHARTS_HOME':
      return { name: 'REPORTS_CHARTS_HOME', label: 'Dashboards' };
    case 'REPORT_CREATION':
      return { name: 'REPORT_CREATION', label: 'New Dashboard' };
    case 'REPORT_DETAIL':
      return {
        name: 'REPORT_DETAIL',
        label: data.title
      };
    case 'SHARED_REPORT':
      return {
        name: 'SHARED_REPORT',
        label: data.title
      };
    case 'CHART_CREATION':
      return { name: 'CHART_CREATION', label: 'New Widget' };
    case 'CHART_DETAIL':
      return {
        name: 'CHART_DETAIL',
        label: data.title
      };
    case 'INVOICE':
      return {
        name: 'INVOICE',
        label: data.invoiceId
      };
    case TAB_PAGES.quote:
      return {
        name: TAB_PAGES.quote,
        label: data.quoteId
      };
    case 'CREATE_TICKET_TEMPLATE':
      return {
        name: 'CREATE_TICKET_TEMPLATE',
        label: 'Create Ticket Template'
      };
    case 'UPDATE_TICKET_TEMPLATE':
      return {
        name: 'UPDATE_TICKET_TEMPLATE',
        label: 'Update Ticket Template'
      };
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return {
        name: 'CREATE_ALERT_EMAIL_TEMPLATE',
        label: 'Create Email Template'
      };
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return {
        name: 'UPDATE_ALERT_EMAIL_TEMPLATE',
        label: 'Update Email Template'
      };
    case 'CANNY_FEEDBACK':
      return {
        name: 'CANNY_FEEDBACK',
        label: 'Feedback'
      };
    // case 'PRODUCT_FORUM':
    //   return {
    //     name: 'PRODUCT_FORUM',
    //     label: 'Forum'
    //   };
    case TAB_PAGES.mailbox:
      return {
        name: TAB_PAGES.mailbox,
        label: 'Mailbox'
      };
    case TAB_PAGES.newInvoice:
      return {
        name: TAB_PAGES.newInvoice,
        label: 'Invoice creation'
      };
    case TAB_PAGES.newInvoiceFromSource:
      return {
        name: TAB_PAGES.newInvoiceFromSource,
        label: 'Invoice creation'
      };
    case TAB_PAGES.newQuote:
      return {
        name: TAB_PAGES.newQuote,
        label: 'Quote creation'
      };
    case 'NOTFOUND':
      return {
        name: 'NOTFOUND',
        label: 'URL NOT FOUND'
      };
    case 'SPEEDTEST':
      return {
        name: 'SPEEDTEST',
        label: `SpeedTest`
      };
    case 'ADVANCE_POLICY_RULE':
      return {
        name: 'ADVANCE_POLICY_RULE',
        label: 'Category Rule Builder'
      };
    case 'REQUESTER_GROUPS':
      return {
        name: 'REQUESTER_GROUPS',
        label: 'Requester Groups'
      };
    case 'NEW_REQUESTER_GROUP':
      return {
        name: 'NEW_REQUESTER_GROUP',
        label: 'New Requester Group'
      };
    case 'EDIT_REQUESTER_GROUP':
      return {
        name: 'EDIT_REQUESTER_GROUP',
        label: `Requester Group: ${data?.name || data?.id}`
      };
    default:
      break;
  }
};

function TabContent(content) {
  return <TabText>{content}</TabText>;
}

/**
 * Render tab content based on modules
 * @param {string} module
 * @param {string} title
 * @public
 */

const getTabIcon = (displayData, params) => {
  const module = displayData?.module || '';
  if (module) {
    switch (module) {
      case TAB_PAGES.newInvoiceFromSource:
        if (params?.data?.module === ALL_MODULES.ticket) {
          return tabIconMap.TICKET;
        } else {
          return tabIconMap[ALL_MODULES.projectDetail];
        }
      default:
        return tabIconMap[module];
    }
  }
};

function renderTab(displayData, params) {
  const title = displayData?.title || '';
  return (
    <Tippy
      content={
        <div className="ai-activator-tippy text-white">
          <FormattedMessage id={title} />
        </div>
      }
      animateFill
      allowHTML
      className="ai-activator-tippy-wrapper"
      arrow
      placement="bottom-start"
      arrow
    >
      <TabContentWrapper className="ellipsis">
        <div className="flex center">
          <div className="mr8 flex">{getTabIcon(displayData, params)}</div>
          <div className="tab-title">
            <FormattedMessage id={title} />
          </div>
        </div>
      </TabContentWrapper>
    </Tippy>
  );
}

const getTabTemplate = (params) => {
  const { ticketId, allTabs, data, tab, module, classId } = params;
  switch (module) {
    case 'CLIENTHOMEKB':
      return renderTab({ title: 'app.nav.home', module });
    case 'AGENTMARKETPLACE':
      return renderTab({ title: 'agentMarketplace.name', module });
    case 'SCHEDULING':
      return renderTab({ title: 'app.modules.workspace.scheduling', module });
    case 'TIMESHEET':
      return renderTab({ title: 'app.modules.workspace.timesheet', module });
    case 'PRODUCTONBOARD':
      return renderTab({
        title: 'admin.usermenu.popup.product.onboarding',
        module
      });
    case 'MIGRATE_DATA':
      return renderTab({
        title: 'product.onboarding.menuItem.migrateData',
        module
      });
    case 'ONBOARD':
      return renderTab({ title: 'app.nav.settings', module });
    case 'HOME':
      return renderTab({ title: 'app.nav.home', module });
    case 'PRICING':
      return renderTab({ title: 'common.pricing', module });
    case 'TICKET':
      return renderTab({ title: data?.subject || 'common.ticket', module });
    case 'ASSET_DETAILS':
    case 'ALL_ASSET_DETAILS':
      return renderTab({
        title: data?.subject || 'common.asset.details',
        module: data.classId ? getAssetTabIconName(data.classId) : module
      });
    case 'NON_MONITORED_ASSET_DETAILS':
      return renderTab({
        title: data?.subject || 'common.non.monitored.asset',
        module
      });
    case ALL_MODULES.projectDetail:
      return renderTab({ title: data?.title || 'entity.project', module });
    case ALL_MODULES.projectCreation:
      return renderTab({
        title: 'tickets.activeprojects.create.header',
        module
      });
    case 'CREATE_SCRIPT':
    case 'SCRIPT_DETAIL':
      return renderTab({ title: data?.title || 'role.feature.script', module });
    case 'CREATE_PROBE':
      return renderTab({ title: data?.title || 'snmp.probe', module });
    case 'CREATE_CREDENTIALS':
      return renderTab({ title: data?.title || 'common.credential', module });
    case 'REPORTS_CHARTS_HOME':
      return renderTab({
        title: data?.title || 'reports.dashboard.title',
        module
      });
    case 'REPORT_CREATION':
      return renderTab({
        title: data?.title || 'common.new.dashboard',
        module
      });
    case 'REPORT_DETAIL':
      return renderTab({
        title: data?.title || 'common.dashboard.detail',
        module
      });
    case 'SHARED_REPORT':
      return renderTab({
        title: data?.title || 'common.shared.dashboard',
        module
      });
    case 'CHART_CREATION':
      return renderTab({ title: data?.title || 'common.new.widget', module });
    case 'CHART_DETAIL':
      return renderTab({
        title: data?.title || 'common.widget.detail',
        module
      });
    case 'CLIENT':
      return renderTab({ title: data?.name || 'common.my.company', module });
    case 'IT_INSIGHT':
      return renderTab({
        title: data?.name || 'admin.stepnavi.mspsettings',
        module
      });
    case 'ALL_CLIENTS':
    case 'SALES_INBOX':
      return renderTab({ title: 'app.modules.client.client', module });
    case 'WORKSPACE':
      return renderTab({
        title: data?.isClientPortal
          ? data?.type === 'TICKETWORKSPACE'
            ? 'notifications.tab.tickets'
            : 'app.nav.home'
          : 'workspace.header',
        module: data?.isClientPortal
          ? data?.type === 'TICKETWORKSPACE'
            ? 'WORKSPACE'
            : 'CLIENT_WORKSPACE'
          : module
      });
    case 'RMM_HOME':
      return renderTab({ title: 'common.assets', module });
    case 'SCRIPTS_HOME':
      return renderTab({ title: 'common.scripts.library', module });
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return renderTab({
        title: data?.title || 'common.community.scripts.details',
        module
      });
    case 'IT_DOCS':
      return renderTab({ title: 'common.documentation', module });
    case 'CLIENT_IT_DOCS':
      return renderTab({ title: 'common.all.documents', module });
    case 'PROFILE':
      return (
        <TabContentWrapper>
          <div className="flex center">
            <div className="mr8">{/* <Clients /> */}</div>
            <div>
              <FormattedMessage id="admin.myprofile.profile.header" />
            </div>
          </div>
        </TabContentWrapper>
      );
    case 'TICKET_VIEW':
      return renderTab({
        title: data?.value || 'common.new.ticket.view',
        module
      });
    case 'NEW':
      return renderTab({ title: data?.value || 'common.new.ticket', module });
    case 'ADD_ALERT_VIEW':
      return renderTab({
        title: data?.value || 'common.new.alert.view',
        module
      });
    case 'ADD_PATCH_VIEW':
      return renderTab({
        title: data?.value || 'common.new.patch.view',
        module
      });
    case 'ADD_ASSET_GROUP_VIEW':
      return renderTab({
        title: data?.value || 'common.new.asset.group.view',
        module
      });
    case 'ADD_ASSET_VIEW':
      return renderTab({
        title: data?.value || 'common.new.asset.view',
        module
      });

    case 'SITE':
      return renderTab({ title: data?.value || 'common.new.site', module });
    case 'CREATE_NON_MONITORED_ASSET_FORM':
      return renderTab({
        title: data?.value || 'common.create.it.documentation',
        module
      });
    case 'CLIENT_CREATION':
      return renderTab({ title: 'common.new.client', module });
    case 'USER':
      return renderTab({
        title: data?.value ? 'common.edit.requester' : 'common.new.requester',
        module
      });
    case 'CREATE_NON_MONITORED_ASSET':
      return renderTab({ title: data?.value || 'common.create.asset', module });
    case 'REQUESTER_GROUPS':
      return renderTab({ title: 'common.requester.groups.list', module });
    case 'NEW_REQUESTER_GROUP':
      return renderTab({ title: 'common.new.requester.group', module });
    case 'EDIT_REQUESTER_GROUP':
      // TODO: Translate this
      return renderTab({
        title: data?.name || `Requester Group: ${data?.id}`,
        module
      });
    case 'KB_ARTICLE':
      return renderTab({
        title: data?.name || 'common.kb.article',
        module: module || 'KNOWLEDGE_BASE'
      });
    case 'UPDATE_ASSET':
      return renderTab({ title: data?.value || 'common.update.asset', module });
    case 'INVOICE':
      // TODO: Translate this
      return renderTab({
        title:
          params?.data?.value || `Invoice ${params?.data?.displayId || ''}`,
        module
      });
    case TAB_PAGES.quote:
      // TODO: Translate this
      return renderTab({
        title: params?.data?.value || `Quote ${params?.data?.displayId || ''}`,
        module
      });
    case 'CREATE_TICKET_TEMPLATE':
      return renderTab({
        title: data?.displayId || 'common.create.ticket.template',
        module
      });
    case 'UPDATE_TICKET_TEMPLATE':
      return renderTab({
        title: data?.displayId || 'common.update.ticket.template',
        module
      });
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return renderTab({
        title: data?.displayId || 'common.create.email.template',
        module
      });
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return renderTab({
        title: data?.displayId || 'common.update.email.template',
        module
      });
    case 'CANNY_FEEDBACK':
      return renderTab({ title: 'common.product.feedback.forum', module });
    // case 'PRODUCT_FORUM':
    //   return renderTab({ title: 'Forum', module });
    case 'CREATE_TERMINAL_SESSION':
      return renderTab({
        title: data?.title || 'role.feature.remoteTerminal',
        class: data?.classId
          ? data?.classId === MAC_POLICY_SET_ID
            ? 'MAC'
            : 'WINDOWS'
          : module,
        module
      });
    case TAB_PAGES.mailbox:
      return renderTab({ title: 'common.new.mail', module });
    case TAB_PAGES.newInvoice:
      return renderTab({ title: 'common.new.invoice', module });
    case TAB_PAGES.newInvoiceFromSource:
      let title;
      if (data?.module === ALL_MODULES.project) {
        title = `New invoice - ${data?.project?.displayId || ''}`;
      } else {
        title = `New invoice - ${data?.ticket?.displayId || ''}`;
      }
      return renderTab({ title, module }, params);
    case TAB_PAGES.newQuote:
      return renderTab({ title: 'common.new.quote', module });
    case 'UPDATE_ASSET_VIEW':
      return renderTab({
        title: params?.data?.value || 'common.update.asset.view',
        module
      });
    case 'UPDATE_ASSET_GROUP_VIEW':
      return renderTab({
        title: params?.data?.value || 'asset.new.update.header',
        module
      });
    case 'UPDATE_ALERT_VIEW':
      return renderTab({
        title: params?.data?.value || 'common.update.alert.view',
        module
      });
    case 'UPDATE_PATCH_VIEW':
      return renderTab({
        title: params?.data?.value || 'common.update.patch.view',
        module
      });
    case 'NEW_CONTRACT_TEMPLATE':
      return renderTab({
        title: params?.data?.value || 'common.new.contract.template',
        module
      });
    case 'EDIT_CONTRACT_TEMPLATE':
      return renderTab({
        title: params?.data?.value || 'common.edit.contract.template',
        module
      });
    case 'NOTFOUND':
      return renderTab({ title: 'common.not.found', module });
    case 'SPEEDTEST':
      return renderTab({ title: 'common.speedtest', module });
    case 'ADVANCE_POLICY_RULE':
      return renderTab({ title: 'common.category.rule.builder', module });
    default:
      break;
  }
};

const getTabContentData = (data, module) => {
  switch (module) {
    case 'CLIENTHOMEKB':
      return { title: data?.value || 'app.nav.home', module };
    case 'AGENTMARKETPLACE':
      return { title: data?.value || 'agentMarketplace.name', module };
    case 'UPDATE_ASSET_VIEW':
      return { title: data?.value || 'common.update.asset.view', module };
    case 'UPDATE_ASSET_GROUP_VIEW':
      return { title: data?.value || 'asset.new.update.header', module };
    case 'UPDATE_ALERT_VIEW':
      return { title: data?.value || 'common.update.alert.view', module };
    case 'UPDATE_PATCH_VIEW':
      return { title: data?.value || 'common.update.patch.view', module };
    case 'UPDATE_ASSET':
      return { title: data?.value || 'common.update.asset', module };
    case 'NEW_CONTRACT_TEMPLATE':
      return { title: data?.value || 'common.new.contract.template', module };
    case 'EDIT_CONTRACT_TEMPLATE':
      return { title: data?.value || 'common.edit.contract.template', module };
    case 'TIMESHEET':
      return { title: 'app.modules.workspace.timesheet', module };
    case TAB_PAGES.scheduling:
      return { title: 'app.modules.workspace.scheduling', module };
    case 'PRODUCTONBOARD':
      return { title: 'admin.usermenu.popup.product.onboarding', module };
    case 'ONBOARD':
      return { title: 'app.nav.settings', module };
    case 'HOME':
      return { title: 'app.nav.home', module };
    case 'PRICING':
      return { title: 'common.pricing', module };
    case 'TICKET':
      return { title: data?.subject || 'common.ticket', module };
    case 'ASSET_DETAILS':
    case 'ALL_ASSET_DETAILS':
      return {
        title: data?.subject || 'common.asset.details',
        module: data.classId ? getAssetTabIconName(data.classId) : module
      };
    case 'NON_MONITORED_ASSET_DETAILS':
      return {
        title: data?.subject || 'common.non.monitored.asset',
        module
      };
    case ALL_MODULES.projectDetail:
      return { title: data?.title || 'entity.project', module };
    case ALL_MODULES.projectCreation:
      return { title: 'tickets.activeprojects.create.header', module };
    case 'CREATE_SCRIPT':
    case 'SCRIPT_DETAIL':
      return { title: data?.title || 'role.feature.script', module };
    case 'CREATE_PROBE':
      return { title: data?.title || 'snmp.probe', module };
    case 'CREATE_CREDENTIALS':
      return { title: data?.title || 'common.credential', module };
    case 'REPORTS_CHARTS_HOME':
      return { title: data?.title || 'reports.dashboard.title', module };
    case 'REPORT_CREATION':
      return { title: data?.title || 'common.new.dashboard', module };
    case 'REPORT_DETAIL':
      return { title: data?.title || 'common.dashboard.detail', module };
    case 'SHARED_REPORT':
      return { title: data?.title || 'common.shared.dashboard', module };
    case 'CHART_CREATION':
      return { title: data?.title || 'common.new.widget', module };
    case 'CHART_DETAIL':
      return { title: data?.title || 'common.widget.detail', module };
    case 'CLIENT':
      return { title: data?.name || 'common.my.company', module };
    case 'ALL_CLIENTS':
    case 'SALES_INBOX':
      return { title: 'app.modules.client.client', module };
    case 'IT_INSIGHT':
      return { title: 'admin.stepnavi.mspsettings', module };
    case 'WORKSPACE':
      return {
        title: data?.isClientPortal
          ? data?.type === 'TICKETWORKSPACE'
            ? 'notifications.tab.tickets'
            : 'app.nav.home'
          : 'workspace.header',
        module: data?.isClientPortal
          ? data?.type === 'TICKETWORKSPACE'
            ? 'WORKSPACE'
            : 'CLIENT_WORKSPACE'
          : module
      };
    case 'RMM_HOME':
      return { title: 'common.assets', module };
    case 'SCRIPTS_HOME':
      return { title: 'common.scripts.library', module };
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return {
        title: data?.title || 'common.community.scripts.details',
        module
      };
    case 'IT_DOCS':
    case 'CLIENT_IT_DOCS':
      return { title: 'common.documentation', module };
    case 'PROFILE':
      return { title: 'admin.myprofile.profile.header', module };
    case 'TICKET_VIEW':
      return { title: data?.value || 'common.new.ticket.view', module };
    case 'NEW':
      return { title: data?.value || 'common.new.ticket', module };
    case 'ADD_ALERT_VIEW':
      return { title: data?.value || 'common.new.alert.view', module };
    case 'ADD_PATCH_VIEW':
      return { title: data?.value || 'common.new.patch.view', module };
    case 'ADD_ASSET_GROUP_VIEW':
      return {
        title: data?.value || 'common.new.asset.group.view',
        module
      };
    case 'ADD_ASSET_VIEW':
      return {
        title: data?.value || 'common.new.asset.view',
        module
      };
    case 'SITE':
      return { title: data?.value || 'common.new.site', module };
    case 'CREATE_NON_MONITORED_ASSET_FORM':
      return {
        title: data?.value || 'common.create.it.documentation',
        module
      };
    case 'KB_ARTICLE':
      return {
        title: data?.name || 'common.kb.article',
        module: module || 'KNOWLEDGE_BASE'
      };
    case 'CLIENT_CREATION':
      return { title: 'common.new.client', module };
    case 'USER':
      return {
        title: data?.value ? 'common.edit.requester' : 'common.new.requester',
        module
      };
    case 'CREATE_NON_MONITORED_ASSET':
      return { title: data?.value || 'common.create.asset', module };
    case 'UPDATE_ASSET':
      return { title: data?.value || 'common.update.asset', module };
    case 'INVOICE':
      return {
        title: data?.value || `Invoice ${data?.displayId || ''}`,
        module
      };
    case TAB_PAGES.quote:
      return {
        title: data?.value || `Quote ${data?.displayId || ''}`,
        module
      };
    case TAB_PAGES.newQuote:
      return { title: 'common.new.quote', module };
    case 'CREATE_TICKET_TEMPLATE':
      return {
        title: data?.displayId || 'common.create.ticket.template',
        module
      };
    case 'UPDATE_TICKET_TEMPLATE':
      return {
        title: data?.displayId || 'common.update.ticket.template',
        module
      };
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return {
        title: data?.displayId || 'common.create.email.template',
        module
      };
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return {
        title: data?.displayId || 'common.update.email.template',
        module
      };
    case 'CANNY_FEEDBACK':
      return { title: 'common.product.feedback.forum', module };
    // case 'PRODUCT_FORUM':
    //   return { title: 'Forum', module };
    case 'CREATE_TERMINAL_SESSION':
      return {
        title: data?.title || 'role.feature.remoteTerminal',
        class: data?.classId
          ? data?.classId === MAC_POLICY_SET_ID
            ? 'MAC'
            : 'WINDOWS'
          : module,
        module
      };
    case TAB_PAGES.mailbox:
      return { title: 'common.new.mail', module };
    case TAB_PAGES.newInvoice:
      return { title: 'common.new.invoice', module };
    case TAB_PAGES.newInvoiceFromSource:
      if (data?.module === ALL_MODULES.ticket) {
        return { title: `New invoice - ${data?.ticket?.displayId}`, module };
      } else {
        return { title: `New invoice - ${data?.project?.displayId}`, module };
      }
    case 'SPEEDTEST':
      return { title: 'common.speedtest', module };
    case 'ADVANCE_POLICY_RULE':
      return { title: 'common.category.rule.builder', module };
    default:
      return { title: 'Unknown tab' };
  }
};

const getTabListContent = ({ module, title }) => {
  return (
    <TabContentWrapper>
      <div className="flex center" title={title}>
        {!!tabIconMap[module] && (
          <div className="mr8 flex">{tabIconMap[module]}</div>
        )}
        <div className="tab-title">
          <FormattedMessage id={title} />
        </div>
      </div>
    </TabContentWrapper>
  );
};

/**
 * The content that has to be displayed in tab
 * @param {object} params
 * @public
 */

const getTabContent = (params) => {
  const { ticketId, allTabs, tab, data, activeTab } = params;
  switch (params.module) {
    default:
      return <TabText>{getTabTemplate(params)}</TabText>;
  }
};

/**
 * Specify what component has to be displayed for each tab type.
 * @param {object} params
 */
const getTabComponent = (params) => {
  const {
    ticketId,
    scriptId,
    tab,
    module,
    data,
    pageName,
    closeTabCallback,
    openTabCallback
  } = params;

  const SuspenseWrapper = (Component, props = {}) => (
    <Suspense
      fallback={
        <div className="flex actr jctr fh">
          <div className="header-img-size">
            <Loading />
          </div>
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );

  switch (module) {
    case 'SCHEDULING':
      return SuspenseWrapper(SchedulingPage, {});
    case 'TIMESHEET':
      return SuspenseWrapper(TimeSheetPage, {});
    case 'PRODUCTONBOARD':
      return SuspenseWrapper(ProductOnboardingPage, {});
    case 'MIGRATE_DATA':
      return SuspenseWrapper(MigrateDataPage, {});
    case 'ONBOARD':
      return SuspenseWrapper(OnboardPage, {});
    case 'HOME':
      return SuspenseWrapper(HomePage, {});
    case 'TICKET':
      return SuspenseWrapper(MainContainer, {
        key: ticketId || data.ticketId,
        id: ticketId || data.ticketId,
        actions: {
          closeTab: closeTabCallback,
          openTicket: openTabCallback,
          openTabWithContent: openTabCallback
        },
        tab
      });
    case 'USER':
      return SuspenseWrapper(ClientUserPage, {});
    case 'WORKSPACE':
      return SuspenseWrapper(StepNavigation, { pageName });
    case 'ALL_CLIENTS':
    case 'SALES_INBOX':
      return SuspenseWrapper(ClientNavigation, {});
    case 'IT_INSIGHT':
      return SuspenseWrapper(InsightsHome, {});
    case 'NEW':
      return SuspenseWrapper(NewTicketContainer, {
        actions: {
          closeTab: closeTabCallback,
          openTicket: openTabCallback
        },
        tab
      });
    case 'CLIENT_CREATION':
      return SuspenseWrapper(ClientManagementPage, {});
    case 'CLIENT':
      return SuspenseWrapper(ClientDetailsPage, {});
    case 'TICKET_VIEW':
      return SuspenseWrapper(ViewIndexPage, {});
    case ALL_MODULES.projectDetail:
    case ALL_MODULES.projectCreation:
      return SuspenseWrapper(ProjectsPage, { module, id: data?.projectId });
    case 'PROFILE':
      return SuspenseWrapper(ProfilePage, {});
    case 'RMM_HOME':
      return SuspenseWrapper(RMMHome, {});
    case 'SCRIPTS_HOME':
      return SuspenseWrapper(ScriptsHome, {});
    case 'COMMUNITY_SCRIPTS_DETAILS':
      return SuspenseWrapper(CommunityScriptDetails, {});
    case 'IT_DOCS':
      return SuspenseWrapper(ITDocumentationList, {});
    case 'CLIENT_IT_DOCS':
      return SuspenseWrapper(ClientPortalITDocumentation, {});
    case 'ADD_ALERT_VIEW':
      return SuspenseWrapper(AlertViewCreate, {});
    case 'ADD_ASSET_GROUP_VIEW':
      return SuspenseWrapper(AssetGroupViewCreateEditPage, {});
    case 'ADD_ASSET_VIEW':
      return SuspenseWrapper(AssetViewCreate, {});
    case 'ADD_PATCH_VIEW':
      return SuspenseWrapper(PatchViewCreate, {});
    case 'UPDATE_ASSET_GROUP_VIEW':
      return SuspenseWrapper(AssetGroupViewCreateEditPage, {});
    case 'UPDATE_ASSET_VIEW':
      return SuspenseWrapper(AssetViewEdit, {});
    case 'UPDATE_ALERT_VIEW':
      return SuspenseWrapper(AlertViewEdit, {});
    case 'UPDATE_PATCH_VIEW':
      return SuspenseWrapper(PatchViewEdit, {});
    case 'ASSET_DETAILS':
    case 'ALL_ASSET_DETAILS':
      return SuspenseWrapper(AssetDetailsDashboard, {
        assetId: data.id,
        classId: data.classId,
        isAssetInClientPortal: data.isAssetInClientPortal
      });
    case `CREATE_NON_MONITORED_ASSET_FORM`:
      return SuspenseWrapper(NonMonitoredAssetCreatePage, {
        page: 'IT_DOCUMENT'
      });
    case 'KB_ARTICLE':
      return SuspenseWrapper(ArticleHomePage, {
        id: data.id,
        type: data.type,
        name: data.name
      });
    case 'CREATE_NON_MONITORED_ASSET':
      return SuspenseWrapper(NonMonitoredAssetCreate, {});
    case 'CREATE_SCRIPT':
      return SuspenseWrapper(NewScriptPage, {});
    case 'CREATE_PROBE':
      return (
        <div className="tab-create-wrapper m20 white-grey-page">
          {SuspenseWrapper(CreateEditPropForm, { padded: true })}
        </div>
      );
    case 'CREATE_CREDENTIALS':
      return (
        <div className="tab-create-wrapper m20 white-grey-page">
          {SuspenseWrapper(CreateEditCredentialForm, { padded: true })}
        </div>
      );
    case 'SCRIPT_DETAIL':
      return SuspenseWrapper(ScriptDetailPage, {
        id: scriptId || data.scriptId
      });
    case 'NON_MONITORED_ASSET_DETAILS':
      return SuspenseWrapper(NonMonitoredAssetDetails, {
        assetId: data.assetId
      });
    case 'NEW_CONTRACT_TEMPLATE':
    case 'EDIT_CONTRACT_TEMPLATE':
      return SuspenseWrapper(ContractTemplatePage, {});
    case 'INVOICE':
      return SuspenseWrapper(InvoiceDetails, {});
    case 'QUOTE':
      return SuspenseWrapper(QuoteDetails, {});
    case 'REQUESTER_GROUPS':
      return SuspenseWrapper(RequesterGroupsList, {});
    case 'NEW_REQUESTER_GROUP':
      return SuspenseWrapper(RequesterGroupForm, { isNew: true });
    case 'EDIT_REQUESTER_GROUP':
      return SuspenseWrapper(RequesterGroupForm, {
        isNew: false,
        id: data?.id
      });
    case 'REPORTS_CHARTS_HOME':
      return SuspenseWrapper(DashboardHome, {});
    case 'REPORT_CREATION':
    case 'REPORT_DETAIL':
      return SuspenseWrapper(EditReport, {});
    case 'SHARED_REPORT':
      return SuspenseWrapper(SharedReport, {});
    case 'CREATE_TICKET_TEMPLATE':
      return SuspenseWrapper(AlertTicketTemplate, { mode: 'CREATE' });
    case 'UPDATE_TICKET_TEMPLATE':
      return SuspenseWrapper(AlertTicketTemplate, {
        id: data.id,
        mode: 'EDIT'
      });
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
      return SuspenseWrapper(NewAlertNotificationTemplate, {});
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      return SuspenseWrapper(EditAlertNotificationTemplate, { id: data.id });
    case 'CANNY_FEEDBACK':
      return SuspenseWrapper(CannyWidget, {});
    case 'CREATE_TERMINAL_SESSION':
      return SuspenseWrapper(AssetTerminalPage, {});
    case TAB_PAGES.mailbox:
      return SuspenseWrapper(CreateEmail, {
        actions: {
          closeTab: closeTabCallback,
          openTicket: openTabCallback
        },
        tab
      });
    case TAB_PAGES.newInvoice:
    case TAB_PAGES.newInvoiceFromSource:
      return SuspenseWrapper(CreateInvoice, {
        actions: {
          closeTab: closeTabCallback,
          openTicket: openTabCallback
        },
        tab
      });
    case TAB_PAGES.newQuote:
      return SuspenseWrapper(CreateQuote, {
        actions: {
          closeTab: closeTabCallback,
          openTicket: openTabCallback
        },
        tab
      });
    case 'NOTFOUND':
      return SuspenseWrapper(ErrorPage, {
        imageURL: `url(${envConfig.imageRoot}svg/PageNotFound.svg)`,
        text: <FormattedMessage id="app.error.somethingWentWrong" />,
        description: (
          <FormattedMessage id="app.error.somethingWentWrong.description" />
        )
      });
    case 'SPEEDTEST':
      return SuspenseWrapper(SpeedTestPage, {});
    case 'ADVANCE_POLICY_RULE':
      return SuspenseWrapper(AdvancePolicyRulePage, {});
    case 'CLIENTHOMEKB':
      return SuspenseWrapper(ClientHomePageKB, {});
    case 'AGENTMARKETPLACE':
      return SuspenseWrapper(AgentMarketplace, {});
    default:
      break;
  }
};

const getServiceName = (params) => {
  const { module } = params;
  // TODO - Change this to Object format like URL
  switch (module) {
    case 'TICKET':
    case 'WORKSPACE':
      return 'TicketService';
    case 'ADD_ALERT_VIEW':
    case 'ADD_PATCH_VIEW':
    case 'ADD_ASSET_GROUP_VIEW':
    case 'ADD_ASSET_VIEW':
    case 'UPDATE_ASSET_GROUP_VIEW':
    case 'UPDATE_ASSET_VIEW':
    case 'UPDATE_ALERT_VIEW':
    case 'UPDATE_PATCH_VIEW':
    case 'CREATE_TERMINAL_SESSION':
    case 'ASSET_DETAILS':
    case 'ALL_ASSET_DETAILS':
    case `CREATE_NON_MONITORED_ASSET_FORM`:
    case `KB_ARTICLE`:
    case 'CREATE_NON_MONITORED_ASSET':
    case 'CREATE_SCRIPT':
    case 'CREATE_PROBE':
    case 'CREATE_CREDENTIALS':
    case 'SCRIPT_DETAIL':
    case 'NON_MONITORED_ASSET_DETAILS':
    case 'RMM_HOME':
    case 'SCRIPTS_HOME':
    case 'COMMUNITY_SCRIPTS_DETAILS':
    case 'IT_DOCS':
    case 'CLIENT_IT_DOCS':
      return 'RMMService';
    case 'SCHEDULING':
    case 'TIMESHEET':
    case 'PRODUCTONBOARD':
    case 'MIGRATE_DATA':
    case 'ONBOARD':
    case 'HOME':
    case 'PRICING':
    case 'USER':
    case 'REQUESTER_GROUPS':
    case 'ALL_CLIENTS':
    case 'IT_INSIGHT':
    case 'SALES_INBOX':
    case 'NEW':
    case 'CLIENT_CREATION':
    case 'CLIENT':
    case 'SITE':
    case 'TICKET_VIEW':
    case ALL_MODULES.projectDetail:
    case 'PROFILE':
    case ALL_MODULES.projectCreation:
    case 'NEW_CONTRACT_TEMPLATE':
    case 'EDIT_CONTRACT_TEMPLATE':
    case 'REPORTS_CHARTS_HOME':
    case 'REPORT_CREATION':
    case 'REPORT_DETAIL':
    case 'SHARED_REPORT':
    case 'CHART_CREATION':
    case 'CHART_DETAIL':
    case 'INVOICE':
    case TAB_PAGES.quote:
    case 'CREATE_TICKET_TEMPLATE':
    case 'UPDATE_TICKET_TEMPLATE':
    case 'CREATE_ALERT_EMAIL_TEMPLATE':
    case 'UPDATE_ALERT_EMAIL_TEMPLATE':
    case 'CANNY_FEEDBACK':
    case TAB_PAGES.mailbox:
    case TAB_PAGES.newInvoice:
    case TAB_PAGES.newInvoiceFromSource:
    case TAB_PAGES.newQuote:
    case 'SPEEDTEST':
    case 'CLIENTHOMEKB':
    case 'AGENTMARKETPLACE':
    case 'REQUESTER_GROUPS':
    case 'NEW_REQUESTER_GROUP':
    case 'EDIT_REQUESTER_GROUP':
      return 'AccountService';
    default:
      return '';
  }
};

const TabText = styled.div`
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
`;

const TabContentWrapper = styled.div`
  .tab-title {
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 80%;
  }
`;

export {
  getTabId,
  getTabUrl,
  getTabDisplayData,
  TabContent,
  getTabContent,
  getTabComponent,
  getTabTemplate,
  getTabContentData,
  getTabListContent,
  getTabUrlNew,
  getServiceName
};
